import {excelApi} from 'common/src/modules/excel/excel.api';
import {z} from 'zod';
import {ToolName} from '../../copilot.enums';
import {ToolExecuteParams, ToolResult} from '../../copilot.types';
import analyzeWorksheetHeaders from '../../utils/analyzeWorksheetHeaders';
import tool from '../../utils/creators/tool';
import toolResult from '../../utils/creators/toolResult';

const inputSchema = z.object({
  fileId: z.string(),
  worksheetIndex: z.number(),
});

export default function analyzeExcelHeadersTool() {
  async function execute({
    toolUtils,
    input: {fileId, worksheetIndex},
    callChain,
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    const fileInfo = toolUtils.getFileById(fileId);

    if (!fileInfo) {
      return toolResult(`Error: File (ID: ${fileId}) not found`);
    }

    const [worksheet] = await excelApi.readExcelFile({
      fileKey: fileInfo.fileKey,
      worksheetIndex,
      rowsLimit: 15,
    });

    const headers = await analyzeWorksheetHeaders(worksheet, toolUtils, callChain);

    return toolResult(JSON.stringify(headers));
  }

  return tool({
    name: ToolName.AnalyzeExcelHeaders,
    description: 'Analyze the headers of an excel worksheet.',
    displayName: 'Getting worksheet headers',
    inputSchema,
    execute,
  });
}
